<template>
  <div class="main-animation">
    <picture class="main-animation__background"
      v-if="staticImageSrc"
      role="none"
      aria-hidden="true">
      <img :src="staticImageSrc" :srcset="staticImage2xSrcSet" />
    </picture>

    <picture class="main-animation__foreground"
      v-if="movingImageSrc"
      role="none"
      aria-hidden="true">
      <img :src="movingImageSrc" :srcset="movingImage2xSrcSet" />
    </picture>
  </div>
</template>

<script>
export default {
  data() {
    return {
      containerClassName: '.main-animation',
      animatedImageClassName: '.main-animation__foreground',
      container: null,
      staticImageSrc: null,
      movingImageSrc: null,
      staticImage2xSrcSet: null,
      movingImage2xSrcSet: null,
      hiDpiBreakpoint: 2560,
    }
  },
  computed: {
    windowWidth() {
      return this.$store.state.data.windowWidth;
    },
    staticImageList() {
      return this.$store.state.data.doodleStaticImageList;
    },
    movingImageList() {
      return this.$store.state.data.doodleMovingImageList;
    },
    image4k() {
      return this.$store.state.data.doodle4kImage;
    },
    is4kImagePresent() {
      return this.image4k && this.image4k.static && this.image4k.moving;
    },
  },
  watch: {
    windowWidth(newWidth) {
      this.setImages(newWidth);
      const maxWidth = this.staticImageList.map(i => i).reverse()[0].width || 1280;
      if (newWidth >= maxWidth && newWidth < this.hiDpiBreakpoint && this.is4kImagePresent) {
        this.staticImage2xSrcSet = `${this.staticImageSrc} 1x, ${this.image4k.static} 2x`;
        this.movingImage2xSrcSet = `${this.movingImageSrc} 1x, ${this.image4k.moving} 2x`;
        return;
      }
      this.staticImage2xSrcSet = null;
      this.movingImage2xSrcSet = null;
    }
  },
  mounted: function() {
    this.setImages(this.windowWidth);
    this.container = document.querySelector(this.containerClassName);
    this.container.addEventListener('mousemove', this.parallax);
  },
  methods: {
    parallax(event) {
      const images = document.querySelectorAll(this.animatedImageClassName);
      images.forEach(shift => {
        const x = (window.innerWidth / 2 - event.pageX) / 90;
        const y = (window.innerHeight / 2 - event.pageY) / 90;
        shift.style.transform = `translateX(${x}px) translateY(${y}px)`;
      });
    },
    setImages(width) {
      if (width >= this.hiDpiBreakpoint && this.is4kImagePresent) {
        this.staticImageSrc = this.image4k.static;
        this.movingImageSrc = this.image4k.moving;
        return;
      }
      ['staticImage', 'movingImage'].forEach(key => {
        const image = this[`${key}List`].filter(item => item.width <= width).reverse()[0];
        this[`${key}Src`] = image && image.src;
      });
    },
  },
  unmounted: function() {
    this.container.removeEventListener('mousemove', this.parallax);
  },
};
</script>

<style lang="scss">
.main-animation {
  position: relative;
  width: 100vw;

  &__background,
  &__foreground {
    display: block;
    width: 100%;
    user-select: none;
    pointer-events: none;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__foreground {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// components/MainPageAnimation.vue